module.exports = __webpack_public_path__ + "static/offer-wireframe-3-9aae74e1a7d972114aac00c57e75be78.jpg";